import { ModelRun, PassAtKRunStatus } from '@scale/shared/types/passAtK';

export function getTemplateVariables(prompt: string) {
  return Array.from(prompt.matchAll(/{{([a-zA-Z0-9_]+)}}/g)).map(match => match[1]);
}

export function getStatusFromModelRuns(modelRuns: ModelRun[]) {
  const erroredRuns = modelRuns.some(modelRun => modelRun.status === PassAtKRunStatus.Error);
  const allRunsCompleted = modelRuns.every(
    modelRun => modelRun.status === PassAtKRunStatus.Completed,
  );
  const allRunsCancelled = modelRuns.every(
    modelRun => modelRun.status === PassAtKRunStatus.Cancelled,
  );
  const status = allRunsCancelled
    ? PassAtKRunStatus.Cancelled
    : erroredRuns
    ? PassAtKRunStatus.Error
    : allRunsCompleted
    ? PassAtKRunStatus.Completed
    : PassAtKRunStatus.Processing;
  return status;
}
